/**
 * 계정별내역 팝업 HTML (새 창용, 스타일 포함)
 */
export function formatWon(value: number | undefined | null): string {
  if (value == null || !Number.isFinite(Number(value))) return '-';
  return `${Math.round(Number(value)).toLocaleString('ko-KR')}원`;
}

function esc(text: unknown): string {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

const POPUP_CSS = `
  * { box-sizing: border-box; }
  body {
    margin: 0;
    font-family: "Pretendard", "Noto Sans KR", sans-serif;
    background: #eef2f6;
    color: #0f172a;
  }
  .analysis-reference-panel {
    padding: 20px 24px 36px;
  }
  .reference-doc {
    flex: 1;
    width: 100%;
    min-width: 0;
  }
  .reference-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 12px;
    padding: 16px 18px;
    background: #fff;
    border: 1px solid #d8dee6;
    border-radius: 4px;
  }
  .reference-head__main { min-width: 0; }
  .reference-head__main h3 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #152536;
    letter-spacing: -0.03em;
    line-height: 1.35;
  }
  .reference-meta {
    margin: 6px 0 0;
    font-size: 13px;
    color: #64748b;
  }
  .reference-layout {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    max-width: 1280px;
    margin: 0 auto;
  }
  .reference-toc {
    position: sticky;
    top: 12px;
    flex: 0 0 280px;
    width: 280px;
    max-height: calc(100vh - 24px);
    overflow: auto;
    padding: 12px 10px;
    background: #fff;
    border: 1px solid #d8dee6;
    border-radius: 4px;
  }
  .reference-toc__title {
    margin: 0 0 8px;
    padding: 0 4px;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
  }
  .reference-toc__list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .reference-toc__btn {
    display: block;
    width: 100%;
    padding: 7px 8px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #334155;
    font-size: 12.5px;
    font-weight: 600;
    text-align: left;
    line-height: 1.35;
    cursor: pointer;
  }
  .reference-toc__btn:hover { background: #f1f5f9; color: #0f172a; }
  .reference-toc__btn.is-active { background: #e8eef5; color: #1e3a5f; }
  .reference-toc__group {
    margin: 8px 0 4px;
    padding: 0 4px;
    font-size: 11px;
    font-weight: 700;
    color: #94a3b8;
    letter-spacing: 0.02em;
  }
  .reference-toc__group:first-of-type { margin-top: 2px; }
  .reference-toc__btn.is-income { border-left: 2px solid #86efac; }
  .reference-toc__btn.is-expense { border-left: 2px solid #fda4af; }
  .reference-summary {
    margin-bottom: 14px;
    padding: 0;
    background: #fff;
    border: 1px solid #d8dee6;
    border-radius: 4px;
    overflow: hidden;
    scroll-margin-top: 12px;
  }
  .reference-summary.is-collapsed .reference-section__body { display: none; }
  .reference-summary.is-collapsed .collapse-chevron { transform: rotate(-90deg); }
  .summary-block {
    margin-bottom: 14px;
  }
  .summary-block:last-child { margin-bottom: 0; }
  .summary-block__head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 8px;
  }
  .summary-block__head h5 {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
  }
  .summary-block__head strong {
    font-size: 14px;
    font-weight: 800;
    color: #0f172a;
    font-variant-numeric: tabular-nums;
  }
  .summary-block.is-income .summary-block__head strong { color: #15803d; }
  .summary-block.is-expense .summary-block__head strong { color: #b91c1c; }
  .summary-account-list {
    list-style: none;
    margin: 0;
    padding: 0;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    overflow: hidden;
  }
  .summary-account-list li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 10px;
    border-bottom: 1px solid #eef2f6;
    background: #fff;
  }
  .summary-account-list li:last-child { border-bottom: 0; }
  .summary-account-list li:nth-child(even) { background: #f8fafc; }
  .summary-account-name {
    min-width: 0;
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
  }
  .summary-account-code {
    display: inline-block;
    margin-right: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #94a3b8;
  }
  .summary-account-meta {
    flex-shrink: 0;
    text-align: right;
  }
  .summary-account-meta .amt {
    display: block;
    font-size: 13px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: #0f172a;
  }
  .summary-account-meta .cnt {
    display: block;
    margin-top: 1px;
    font-size: 11px;
    color: #94a3b8;
  }
  .account-gubun {
    flex-shrink: 0;
    padding: 2px 7px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 700;
  }
  .account-gubun.is-income { background: #dcfce7; color: #166534; }
  .account-gubun.is-expense { background: #ffe4e6; color: #9f1239; }
  .reference-toc__actions {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #e2e8f0;
  }
  .reference-toc__action {
    width: 100%;
    padding: 6px 8px;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    background: #f8fafc;
    color: #475569;
    font-size: 11.5px;
    font-weight: 600;
    cursor: pointer;
  }
  .reference-toc__action:hover { background: #eef2f6; }
  .reference-intro {
    margin: 0 0 16px;
    padding: 10px 12px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 13px;
    line-height: 1.5;
    color: #475569;
  }
  .reference-section {
    margin-bottom: 14px;
    padding: 0;
    background: #fff;
    border: 1px solid #d8dee6;
    border-radius: 4px;
    overflow: hidden;
    scroll-margin-top: 12px;
  }
  .reference-section__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0;
    padding: 12px 14px;
    border-bottom: 1px solid #eef2f6;
    cursor: pointer;
    user-select: none;
  }
  .reference-section__head:hover { background: #f8fafc; }
  .reference-section__title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }
  .reference-section__head h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
  }
  .collapse-chevron {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    color: #64748b;
    transition: transform 0.15s ease;
  }
  .reference-section.is-collapsed .collapse-chevron,
  .labor-ratio.is-collapsed .collapse-chevron {
    transform: rotate(-90deg);
  }
  .reference-section__body {
    padding: 12px 16px 14px;
  }
  .reference-section.is-collapsed .reference-section__body,
  .labor-ratio.is-collapsed .labor-ratio__body {
    display: none;
  }
  .reference-note {
    margin: 0 0 10px;
    font-size: 12px;
    color: #64748b;
    line-height: 1.45;
  }
  .reference-compare {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 10px;
  }
  .reference-compare__item {
    padding: 8px 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 3px;
  }
  .reference-compare__item span {
    display: block;
    font-size: 11px;
    color: #64748b;
  }
  .reference-compare__item strong {
    display: block;
    margin-top: 2px;
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
  }
  .reference-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }
  .reference-table th,
  .reference-table td {
    padding: 6px 8px;
    border-bottom: 1px solid #e2e8f0;
    text-align: left;
    vertical-align: top;
  }
  .reference-table th {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    background: #f8fafc;
  }
  .reference-table td.num {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
  .reference-table td.memo {
    max-width: 280px;
    word-break: break-word;
  }
  .reference-empty {
    margin: 0;
    font-size: 12px;
    color: #94a3b8;
  }
  .reference-count {
    margin: 0 0 8px;
    font-size: 12px;
    color: #64748b;
  }
  .labor-ratio {
    margin-bottom: 14px;
    padding: 0;
    background: #fff;
    border: 1px solid #d8dee6;
    border-radius: 4px;
    overflow: hidden;
    scroll-margin-top: 12px;
  }
  .labor-ratio__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0;
    padding: 12px 14px;
    border-bottom: 1px solid #eef2f6;
    cursor: pointer;
    user-select: none;
  }
  .labor-ratio__head:hover { background: #f8fafc; }
  .labor-ratio__head h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
  }
  .labor-ratio__body { padding: 12px 16px 16px; }
  .labor-ratio__formula {
    margin: 0 0 12px;
    padding: 8px 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 3px;
    font-size: 13px;
    color: #334155;
  }
  .labor-ratio__block {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid #e2e8f0;
  }
  .labor-ratio__block h5 {
    margin: 0 0 6px;
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
  }
  .labor-steps {
    display: grid;
    gap: 6px;
    margin: 0 0 4px;
  }
  .labor-step {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 3px;
    font-size: 13px;
  }
  .labor-step span { color: #64748b; }
  .labor-step strong { color: #0f172a; text-align: right; }
  .labor-step.is-warn strong { color: #e65100; }
  .reference-badge {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 600;
  }
  .reference-badge.is-ok { background: #e8f5e9; color: #2e7d32; }
  .reference-badge.is-warn { background: #fff3e0; color: #e65100; }
  @media (max-width: 860px) {
    .reference-layout { flex-direction: column; }
    .reference-toc {
      position: static;
      width: 100%;
      flex-basis: auto;
      max-height: none;
    }
    .reference-toc__list {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 4px;
    }
  }
`;

const COLLAPSE_CHEVRON = `<svg class="collapse-chevron" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"/></svg>`;

const REFERENCE_INTERACTION_JS = `
(function () {
  function setCollapsed(section, collapsed) {
    section.classList.toggle('is-collapsed', collapsed);
    var btn = section.querySelector('[data-collapse-toggle]');
    if (btn) btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }
  document.querySelectorAll('[data-collapse-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var section = btn.closest('[data-collapsible]');
      if (!section) return;
      setCollapsed(section, !section.classList.contains('is-collapsed'));
    });
  });
  document.querySelectorAll('[data-scroll-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-scroll-target');
      var el = id && document.getElementById(id);
      if (!el) return;
      if (el.classList.contains('is-collapsed')) setCollapsed(el, false);
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      document.querySelectorAll('.reference-toc__btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
    });
  });
  var expandAll = document.querySelector('[data-expand-all]');
  var collapseAll = document.querySelector('[data-collapse-all]');
  if (expandAll) {
    expandAll.addEventListener('click', function () {
      document.querySelectorAll('[data-collapsible]').forEach(function (s) { setCollapsed(s, false); });
    });
  }
  if (collapseAll) {
    collapseAll.addEventListener('click', function () {
      document.querySelectorAll('[data-collapsible]').forEach(function (s) { setCollapsed(s, true); });
    });
  }
})();
`;

export function buildAnalysisReferenceLoadingHtml(): string {
  return `<!DOCTYPE html>
<html lang="ko">
<head>
  <meta charset="utf-8" />
  <title>계정별내역</title>
  <style>
    body { margin: 0; font-family: "Pretendard", "Noto Sans KR", sans-serif;
      display: flex; align-items: center; justify-content: center;
      min-height: 100vh; background: #f8fafc; color: #475569; }
    p { font-size: 15px; font-weight: 600; }
  </style>
</head>
<body><p>계정별내역 불러오는 중...</p></body>
</html>`;
}

export function buildAnalysisReferenceErrorHtml(message: string): string {
  return `<!DOCTYPE html>
<html lang="ko">
<head>
  <meta charset="utf-8" />
  <title>계정별내역</title>
</head>
<body style="font-family:sans-serif;padding:24px;color:#b91c1c">${esc(message)}</body>
</html>`;
}

function entryTableHtml(
  entries: any[],
  showCodes: boolean,
  amountLabel: string,
  amountOf: (entry: any) => number
): string {
  if (!entries?.length) return '<p class="reference-empty">해당 내역 없음</p>';
  const rows = entries.map((entry) => `
    <tr>
      <td>${esc(entry.date || entry.label || '-')}</td>
      ${showCodes ? `<td>${esc(entry.scode || '-')}</td>` : ''}
      <td>${esc(entry.sname || entry.label || '')}</td>
      <td class="memo">${esc(entry.memo || '')}</td>
      <td class="num">${esc(formatWon(amountOf(entry)))}</td>
    </tr>`).join('');
  return `
    <p class="reference-count">${esc(entries.length)}건</p>
    <table class="reference-table">
      <thead>
        <tr>
          <th>일자</th>
          ${showCodes ? '<th>코드</th>' : ''}
          <th>계정</th>
          <th>적요</th>
          <th>${esc(amountLabel)}</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>`;
}

function groupTableHtml(groups: any[], showCodes: boolean): string {
  if (!groups?.length) return '';
  const rows = groups.map((group) => `
    <tr>
      ${showCodes ? `<td>${esc(group.scode || '-')}</td>` : ''}
      <td>${esc(group.sname)}</td>
      <td class="num">${esc(formatWon(group.amount))}</td>
      <td class="num">${esc(group.count)}</td>
    </tr>`).join('');
  return `
    <table class="reference-table">
      <thead>
        <tr>
          ${showCodes ? '<th>코드</th>' : ''}
          <th>계정</th>
          <th>합계</th>
          <th>건수</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>`;
}

function buildLaborRatioHtml(detail: any, showCodes: boolean): string {
  if (!detail) return '';
  const stepsHtml = (detail.steps || []).map((step: any) => `
    <div class="labor-step${step.warn ? ' is-warn' : ''}">
      <span>${esc(step.label)}${step.hint ? ` · ${esc(step.hint)}` : ''}</span>
      <strong>${esc(step.text != null ? step.text : formatWon(step.amount))}</strong>
    </div>`).join('');

  const incomeGroups = groupTableHtml(detail.income?.groups || [], showCodes);
  const incomeEntries = entryTableHtml(
    detail.income?.entries || [],
    showCodes,
    '수입',
    (e) => e.income ?? e.amount
  );

  let expenseBody = '';
  if (detail.expense?.fromWage) {
    const wageRows = (detail.expense.wageRows || []).map((row: any) => `
      <tr>
        <td>${esc(row.label || row.yearMonth)}</td>
        <td>${esc(row.bizGubun || '-')}</td>
        <td class="num">${esc(formatWon(row.laborCost))}</td>
        <td class="num">${esc(formatWon(row.laborAdd))}</td>
        <td class="num">${esc(formatWon(row.amount))}</td>
      </tr>`).join('');
    expenseBody = `
      <p class="reference-note">${esc(detail.expense.note || '')}</p>
      <p class="reference-count">월별 ${(detail.expense.wageRows || []).length}건 · 합계 ${esc(formatWon(detail.expense.wageTotal))}</p>
      <table class="reference-table">
        <thead>
          <tr>
            <th>연월</th>
            <th>사업구분</th>
            <th>인건비</th>
            <th>인건비가산</th>
            <th>합계</th>
          </tr>
        </thead>
        <tbody>${wageRows || '<tr><td colspan="5">임금자료 없음</td></tr>'}</tbody>
      </table>
      <p class="reference-note" style="margin-top:10px">
        인건비 ${esc(formatWon(detail.expense.wageCostTotal))}
        + 인건비가산 ${esc(formatWon(detail.expense.wageAddTotal))}
        = ${esc(formatWon(detail.expense.wageTotal))}
        (보고서 지출에 사용)
      </p>
      <p class="reference-note">장부 인건비 계정 합계(참고): ${esc(formatWon(detail.expense.bookTotal))}</p>
      ${groupTableHtml(detail.expense.bookGroups || [], showCodes)}
    `;
  } else {
    expenseBody = `
      <p class="reference-note">${esc(detail.expense?.note || '')}</p>
      ${groupTableHtml(detail.expense?.bookGroups || [], showCodes)}
      ${entryTableHtml(
        detail.expense?.bookEntries || [],
        showCodes,
        '지출',
        (e) => e.expense ?? e.amount
      )}
    `;
  }

  return `
    <section id="sec-labor" class="labor-ratio is-collapsed" data-collapsible>
      <div class="labor-ratio__head" data-collapse-toggle role="button" tabindex="0" aria-expanded="false">
        <div class="reference-section__title">
          ${COLLAPSE_CHEVRON}
          <h4>${esc(detail.title || '인건비지출비율')}</h4>
        </div>
        <span class="reference-badge ${detail.met ? 'is-ok' : 'is-warn'}">
          ${detail.met ? '충족' : '미충족'}
        </span>
      </div>
      <div class="labor-ratio__body">
        <p class="labor-ratio__formula">${esc(detail.formula)}</p>
        <div class="labor-steps">${stepsHtml}</div>

        <div class="labor-ratio__block">
          <h5>인건비수입 구성 · ${esc(formatWon(detail.income?.total))}</h5>
          <p class="reference-note">${esc(detail.income?.note || '')}</p>
          ${incomeGroups}
          ${incomeEntries}
        </div>

        <div class="labor-ratio__block">
          <h5>인건비지출 구성 · ${esc(formatWon(detail.expense?.total))}</h5>
          ${expenseBody}
        </div>
      </div>
    </section>`;
}

export function buildAnalysisReferenceHtml(data: any): string {
  const showCodes = !!data.showAccountCodes;
  const period =
    data.periodRange || data.periodLabel
      ? ` · ${esc(data.periodRange || data.periodLabel)}`
      : '';
  const biz = data.bizLabel ? ` · ${esc(data.bizLabel)}` : '';

  const laborRatioHtml = buildLaborRatioHtml(data.laborRatioDetail, showCodes);
  const laborTitle = data.laborRatioDetail?.title || '인건비지출비율';

  const summary = data.summary || {
    income: [],
    expense: [],
    incomeTotal: 0,
    expenseTotal: 0,
  };
  const accounts: any[] = Array.isArray(data.accounts) && data.accounts.length
    ? data.accounts
    : [];

  type TocItem = { id: string; title: string; kind?: 'summary' | 'labor' | 'income' | 'expense' };
  const tocItems: TocItem[] = [
    { id: 'sec-summary', title: '요약 · 계정별 합계', kind: 'summary' },
  ];
  if (laborRatioHtml) {
    tocItems.push({ id: 'sec-labor', title: laborTitle, kind: 'labor' });
  }

  const renderSummaryRows = (rows: any[], showCode: boolean) => {
    if (!rows?.length) return '<p class="reference-empty">해당 내역 없음</p>';
    return `
      <ul class="summary-account-list">
        ${rows.map((row) => `
          <li>
            <span class="summary-account-name">
              ${showCode && row.scode ? `<span class="summary-account-code">${esc(row.scode)}</span>` : ''}
              ${esc(row.sname || '계정')}
            </span>
            <span class="summary-account-meta">
              <span class="amt">${esc(formatWon(row.amount))}</span>
              <span class="cnt">${esc(row.count || 0)}건</span>
            </span>
          </li>`).join('')}
      </ul>`;
  };

  const summaryHtml = `
    <section id="sec-summary" class="reference-summary is-collapsed" data-collapsible>
      <div class="reference-section__head" data-collapse-toggle role="button" tabindex="0" aria-expanded="false">
        <div class="reference-section__title">
          ${COLLAPSE_CHEVRON}
          <h4>요약 · 계정별 합계</h4>
        </div>
      </div>
      <div class="reference-section__body">
        <div class="summary-block is-income">
          <div class="summary-block__head">
            <h5>수입</h5>
            <strong>${esc(formatWon(summary.incomeTotal))}</strong>
          </div>
          ${renderSummaryRows(summary.income || [], showCodes)}
        </div>
        <div class="summary-block is-expense">
          <div class="summary-block__head">
            <h5>지출</h5>
            <strong>${esc(formatWon(summary.expenseTotal))}</strong>
          </div>
          ${renderSummaryRows(summary.expense || [], showCodes)}
        </div>
      </div>
    </section>`;

  const accountsHtml = accounts.map((acc) => {
    const isIn = acc.gubun === 'IN' || acc.gubunLabel === '수입';
    const amountLabel = isIn ? '수입' : '지출';
    tocItems.push({
      id: acc.id,
      title: acc.tocTitle || `${amountLabel} - ${acc.sname || '계정'}`,
      kind: isIn ? 'income' : 'expense',
    });

    const entries = acc.entries || [];
    let body = '<p class="reference-empty">해당 계정 내역 없음</p>';
    if (entries.length) {
      const rows = entries.map((entry: any) => {
        const amt = isIn ? (entry.income ?? entry.amount) : (entry.expense ?? entry.amount);
        return `
          <tr>
            <td>${esc(entry.date || '-')}</td>
            <td class="memo">${esc(entry.memo || '')}</td>
            <td class="num">${esc(formatWon(amt))}</td>
          </tr>`;
      }).join('');
      body = `
        <p class="reference-count">${esc(acc.count || entries.length)}건 · 합계 ${esc(formatWon(acc.amount))}</p>
        <table class="reference-table">
          <thead>
            <tr>
              <th>일자</th>
              <th>적요</th>
              <th>${amountLabel}</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>`;
    }

    return `
      <section id="${esc(acc.id)}" class="reference-section is-collapsed" data-collapsible>
        <div class="reference-section__head" data-collapse-toggle role="button" tabindex="0" aria-expanded="false">
          <div class="reference-section__title">
            ${COLLAPSE_CHEVRON}
            <span class="account-gubun ${isIn ? 'is-income' : 'is-expense'}">${esc(amountLabel)}</span>
            <h4>
              ${showCodes && acc.scode ? `<span class="summary-account-code">${esc(acc.scode)}</span>` : ''}
              ${esc(acc.sname || '계정')}
            </h4>
          </div>
          <strong style="font-size:13px;font-variant-numeric:tabular-nums">${esc(formatWon(acc.amount))}</strong>
        </div>
        <div class="reference-section__body">${body}</div>
      </section>`;
  }).join('');

  // 목차: 요약/인건비 후 수입·지출 그룹
  const tocBlocks: string[] = [];
  let currentList: string[] = [];
  const flushList = () => {
    if (!currentList.length) return;
    tocBlocks.push(`<ul class="reference-toc__list">${currentList.join('')}</ul>`);
    currentList = [];
  };
  let lastKind = '';
  for (const item of tocItems) {
    if (item.kind === 'income' && lastKind !== 'income') {
      flushList();
      tocBlocks.push('<p class="reference-toc__group">수입</p>');
    }
    if (item.kind === 'expense' && lastKind !== 'expense') {
      flushList();
      tocBlocks.push('<p class="reference-toc__group">지출</p>');
    }
    const kindClass = item.kind === 'income'
      ? ' is-income'
      : item.kind === 'expense'
        ? ' is-expense'
        : '';
    currentList.push(`
      <li>
        <button
          type="button"
          class="reference-toc__btn${kindClass}${item.id === 'sec-summary' ? ' is-active' : ''}"
          data-scroll-target="${esc(item.id)}"
        >${esc(item.title)}</button>
      </li>`);
    lastKind = item.kind || lastKind;
  }
  flushList();

  const tocHtml = `
    <aside class="reference-toc" aria-label="목차">
      <p class="reference-toc__title">목차</p>
      ${tocBlocks.join('')}
      <div class="reference-toc__actions">
        <button type="button" class="reference-toc__action" data-expand-all>모두 펼치기</button>
        <button type="button" class="reference-toc__action" data-collapse-all>모두 접기</button>
      </div>
    </aside>`;

  const intro = '분석기간 통장내역을 계정별로 묶은 내역입니다. 요약에서 계정 합계를 보고, 각 계정에서 전표를 확인할 수 있습니다.';

  return `<!DOCTYPE html>
<html lang="ko">
<head>
  <meta charset="utf-8" />
  <title>${esc(data.title || '계정별내역')}</title>
  <style>${POPUP_CSS}</style>
</head>
<body>
  <div class="analysis-reference-panel">
    <div class="reference-layout">
      ${tocHtml}
      <div class="reference-doc">
        <header class="reference-head">
          <div class="reference-head__main">
            <h3>${esc(data.title || '계정별내역')}</h3>
            <p class="reference-meta">${esc(data.memberName)}${biz}${period}</p>
          </div>
        </header>
        <p class="reference-intro">${intro}</p>
        ${summaryHtml}
        ${laborRatioHtml}
        ${accountsHtml}
      </div>
    </div>
  </div>
  <script>${REFERENCE_INTERACTION_JS}</script>
</body>
</html>`;
}
